import React from "react";

const Spinner = ({message}) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only spin-text">Učitavam...</span>
      </div>
    </div>
  );
};

export default Spinner;
